import { WhatsGlyph } from "./WhatsGlyph";
import { waLink, DEFAULT_MSG } from "@/data/site";

export const FloatingWhatsapp = () => (
  <a
    href={waLink(DEFAULT_MSG)}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Falar no WhatsApp"
    data-testid="floating-whatsapp-btn"
    className="group isolate fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-wa shadow-[0_8px_30px_rgba(37,211,102,0.45)] transition-transform hover:scale-110"
  >
    <span className="pulse-ring absolute inset-0 rounded-full" aria-hidden="true" />
    <WhatsGlyph className="relative h-7 w-7 text-[#052e16]" />
    <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full border border-white/10 bg-ink/90 px-4 py-2 font-mono text-xs text-white opacity-0 backdrop-blur-md transition-opacity group-hover:opacity-100 md:block">
      Dúvidas? Fale no WhatsApp
    </span>
  </a>
);
